<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="lg"
    :modal-title="`${this.selectedFile ? '파일 링크 상세' : '파일 링크 추가'}`"
    :close="close"
    :loading="loading"
    :confirmButtonTitle="`${this.selectedFile ? '수정' : '추가'}`"
    :confirm="update"
    name="fileDetailModal"
  >
    <b-container>
      <b-row>
        <b-form-group label="이름" label-cols-sm="3" label-size="sm">
          <b-form-input
            id="inline-form-input-name"
            class=" mr-sm-2 md-4"
            placeholder="이름을 입력해주세요."
            v-model="name"
          />
        </b-form-group>
        <b-form-group label="업로드 파일" label-cols-sm="3" label-size="sm">
          <input type="file" id="upload-image" @change="setFile($event.target.files)"/>
        </b-form-group>
        <b-form-group label="기존 파일 경로" label-cols-sm="3" label-size="sm" v-if="selectedFile">
          {{originFilePath}}
        </b-form-group>
        <b-form-group label="기존 파일명" label-cols-sm="3" label-size="sm" v-if="selectedFile">
          {{originFileName}}
        </b-form-group>
        <b-form-group label="세 파일 경로" label-cols-sm="3" label-size="sm" v-if="file">
          <div class="flex inline-flex items-center w-full gap-2">
            <b-form-input
              id="inline-form-input-name"
              class=" mr-sm-2 md-4"
              placeholder="파일 경로를 입력하세요."
              v-model="filePath"
            />
            <span v-if="extension">{{extension}}</span>
          </div>
          <p class="text-rose-700 text-sm">파일 경로는 영어로 입력해주세요. (예 : mission1/book)</p>
        </b-form-group>
        <b-form-group label="강의 교재 노출 여부" label-cols-sm="3" label-size="sm" v-if="!!selected">
          <b-form-radio-group
            v-model="publishStatus"
            :options="publishOptions"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          />
          <b-form-group label="클릭 시 팝업 내용" label-cols-sm="3" label-size="sm">
            <b-form-input
              id="inline-form-input-name"
              class=" mr-sm-2 md-4"
              placeholder="팝업 내용을 입력해주세요."
              v-model="popupContent"
            />
          </b-form-group>
          <b-form-group label="접속코드 없이 교재 노출" label-cols-sm="3" label-size="sm">
            <b-form-checkbox
              id="inline-form-input-name"
              class=" mr-sm-2 md-4"
              v-model="passUnlock"
            />
          </b-form-group>
        </b-form-group>
        <b-form-group label="메모" label-cols-sm="3" label-size="sm">
          <b-form-textarea
            id="textarea"
            v-model="memo"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
      </b-row>
    </b-container>
  </AdminModal>
</template>
<script>
import AdminModal from "@/components/modals/AdminModal.vue";
import customDate from "@/util/custom-date"
import api from "@/api/api"
import {copyText} from "vue3-clipboard";

export default {
  name: "FileDetailModal",
  components: {AdminModal},
  data() {
    return {
      name: "",
      url: '',
      file: null,
      originFilePath: "",
      originFileName: "",
      filePath: '',
      extension: '',
      memo: "",
      selected: null,
      passUnlock: false,
      popupContent: "",
      publishStatus: "UNPUBLISHED",
      options: [{
        value: null,
        text: "없음"
      }],
      loading: false,
      publishOptions: [
        { item: "PUBLISHED", name: '노출' },
        { item: "UNPUBLISHED", name: '비노출' },
      ]
    }
  },
  props: ['isOpen', 'close', 'reload', 'selectedFile'],
  mounted() {
    if (this.selectedFile) {
      const filePath = this.selectedFile.url?.split(".")
      this.id = this.selectedFile.id
      this.name = this.selectedFile.name
      this.url = this.selectedFile.url
      this.memo = this.selectedFile.memo
      this.selected = this.selectedFile.lessonContentId
      this.publishStatus = this.selectedFile.status
      this.popupContent = this.selectedFile.popupContent
      this.filePath = filePath?.[0] || ""
      this.extension = `${filePath?.[1] ? `.${filePath?.[1]}` : ""}` || ""
      this.originFilePath = `https://file.kessam.com/${this.selectedFile.url}`
      this.originFileName = this.selectedFile.fileName
      this.passUnlock = this.selectedFile.passUnlock
    }
   
    this.getLessonContents()
  },
  methods: {
    getURL(url) {
      return `https://file.kessam.com/${url}`
    },
    copy(url){
      const fullURL = this.getURL(url)
      copyText(fullURL, fullURL, (err, event) => {
        this.$toast.show(err ? '복사 할 수 없습니다.' : '복사 완료',
          {
            position: "top-right",
            duration: 2000
          });
      })
    },
    getLessonContents() {
      api.lesson.lessonContents({},(response) => {
        this.options = this.options.concat(response.data.map((lessonContent) => ({
          value: lessonContent.id,
          text: `${lessonContent.lessonTitle}(${lessonContent.title})`
        })))
      }, (err) => {
        console.log(err)
      })
    },
    getDate(date) {
      return customDate.stringFormat(date)
    },
    update(){
      if (this.name.length === 0) {
        this.$toast.error('이름을 입력해주세요.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }
      
      this.loading = true
      api.file.updateFile({
        id: this.id,
        memo: this.memo,
        name: this.name,
        filePath: this.filePath,
        status: this.publishStatus,
        lessonContentId: this.selected,
        popupContent : this.popupContent || "",
        passUnlock: this.passUnlock,
        file: this.file,
      },(response) => {
        this.loading = false
        this.reload()
        this.close()
      }, (err) => {
        this.loading = false
        console.log(err)
        this.$toast.error(err.message,
          {
            position: "top-right",
            duration: 2000
          })
      })
    },
    setFile(files) {
      const getFileNameAntExtension = (fileName) => {
        const lastIndexOfDot = fileName.lastIndexOf('.')
        return  {
          extension: fileName.substring(lastIndexOfDot, fileName.length),
          name: fileName.substring(0, lastIndexOfDot)
        }
      }

      this.file = files[0]
      const info = getFileNameAntExtension(this.file.name)
      this.extension = info.extension
      if (!this.filePath) {
        this.filePath = info.name
      }
    },
  }
}
</script>
<style scoped>

</style>